import { Grid, Stack, Typography } from '@mui/material';

import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import TabsLayout from 'components/TabsLayout/TabsLayout';

import Banner from 'common/components/Banner/Banner';
import { SETTINGS_DASHBOARD } from 'common/constants';
import { FeatureFlagsKeysEnum } from 'common/constants/FeatureFlags';
import { RootState } from 'common/store/AppStore';
import { scrollToTop } from 'common/utils/utilFunctions';

import { useFeatureFlag } from 'hooks/useFeatureFlags';
import useTableQuery from 'hooks/useTableQuery';

import { getTabs } from './TabsData/TabsData';

import styles from './Settings.module.scss';

const Settings = () => {
	const { SETTINGS_BANNER_TITLE, SETTINGS_BANNER_BODY } = SETTINGS_DASHBOARD;

	const { updateTableQuery: updateQueueListQuery } = useTableQuery({
		id: 'queueListTable',
	});
	const { updateTableQuery: updateWorkflowListQuery } = useTableQuery({
		id: 'workflowListTable',
	});
	const tabIndex = useSelector((state: RootState) => state.settings.currentTab);

	useEffect(() => {
		const defaultQuery = {
			pageNumber: 0,
			pageSize: 10,
		};
		updateQueueListQuery(defaultQuery);
		updateWorkflowListQuery(defaultQuery);
	}, [tabIndex]);

	useEffect(() => {
		scrollToTop();
	}, []);

	const features = {
		isAdminOverviewEnabled: useFeatureFlag(
			FeatureFlagsKeysEnum.IS_ADMIN_OVERVIEW_ENABLED,
		),
		isAdminUserManagementEnabled: useFeatureFlag(
			FeatureFlagsKeysEnum.IS_ADMIN_USER_MANAGEMENT_ENABLED,
		),
		isAdminPermissionsEnabled: useFeatureFlag(
			FeatureFlagsKeysEnum.IS_ADMIN_PERMISSIONS_ENABLED,
		),
		isAdminQueueWorkflowEnabled: useFeatureFlag(
			FeatureFlagsKeysEnum.IS_ADMIN_QUEUE_WORKFLOW_ENABLED,
		),
		isAdminSystemEnabled: useFeatureFlag(
			FeatureFlagsKeysEnum.IS_ADMIN_SYSTEM_ENABLED,
		),
		isAdminNotificationsEnabled: useFeatureFlag(
			FeatureFlagsKeysEnum.IS_ADMIN_NOTIFICATIONS_ENABLED,
		),
		isAdminSecurityEnabled: useFeatureFlag(
			FeatureFlagsKeysEnum.IS_ADMIN_SECURITY_ENABLED,
		),
		isAdminJobSchedulerEnabled: useFeatureFlag(
			FeatureFlagsKeysEnum.IS_ADMIN_JOB_SCHEDULER_ENABLED,
		),
		isAdminEscalationEnabled: useFeatureFlag(
			FeatureFlagsKeysEnum.IS_ADMIN_ESCALATION_ENABLED,
		),
		isAdminChecklistEnabled: useFeatureFlag(
			FeatureFlagsKeysEnum.IS_ADMIN_CHECKLIST_ENABLED,
		),
		isAdminPromptBuilderEnabled: useFeatureFlag(
			FeatureFlagsKeysEnum.IS_ADMIN_PROMPT_BUILDER_ENABLED,
		),
		isAdminResetEnabled: useFeatureFlag(
			FeatureFlagsKeysEnum.IS_ADMIN_RESET_ENABLED,
		),
	};

	const tabs = getTabs(features);

	return (
		<div data-testid="main-box">
			<Banner>
				<Stack p={2} className={styles['settings-header-wrapper']}>
					<Typography className={styles['settings-banner-heading']}>
						{SETTINGS_BANNER_TITLE}
					</Typography>
					<Typography mt={0} className={styles['settings-banner-content']}>
						{SETTINGS_BANNER_BODY}
					</Typography>
				</Stack>
			</Banner>
			<Grid
				container
				spacing={2}
				data-testid="main-content"
				className={styles['main-content']}
			>
				<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
					<TabsLayout activetab={tabIndex} tabs={tabs} isTabBar />
				</Grid>
			</Grid>
		</div>
	);
};
export default Settings;
